export type GalleryTab = 'alles' | 'mijn' | 'videos'

/**
 * De drie pillen boven de galerij. De actieve is massief inktkleur; dat is de
 * enige plek in het product waar --color-ink als vlak gebruikt wordt, en
 * daarom valt hij ook zo op.
 */
export function FilterTabs({
  active,
  mineCount,
  showMine = true,
  onChange,
}: {
  active: GalleryTab
  mineCount: number | null

  /**
   * "Mijn foto's" weglaten. Voor de eigenaar die meekijkt zonder gast te zijn:
   * die heeft er geen, dus zou de tab altijd leeg zijn.
   */
  showMine?: boolean

  onChange: (tab: GalleryTab) => void
}) {
  const tabs: { id: GalleryTab; label: string }[] = [
    { id: 'alles', label: 'Alles' },
    ...(showMine
      ? [
          {
            id: 'mijn' as const,
            label: mineCount === null ? 'Mijn foto’s' : `Mijn foto’s · ${mineCount}`,
          },
        ]
      : []),
    { id: 'videos', label: 'Video’s' },
  ]

  return (
    <div role="tablist" aria-label="Filter" className="scroll-x-clean flex gap-2">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={tab.id === active}
          onClick={() => onChange(tab.id)}
          className={
            // Op mobiel kleiner: drie pillen van elk elf millimeter hoog kosten
            // een volle band boven het raster, en ze zijn tekst — niet het
            // onderwerp van het scherm. Vanaf lg staan ze weer ruim.
            'shrink-0 rounded-full px-3.5 py-1.5 text-[13px] whitespace-nowrap transition-colors ' +
            'lg:px-4.5 lg:py-2.5 lg:text-sm ' +
            (tab.id === active
              ? 'bg-ink text-shell font-medium'
              : 'border-line text-ink-muted border')
          }
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
